
import { Placement } from '@post-office/placements-frontend/quick-find-spotlight';
export default Placement;
